import { connect } from 'react-redux';

import { Fotorama, IFotoramaDispatchProps, IFotoramaStoreProps } from '../../components/Fotorama';
import { getSlides } from '../../selectors/fotorama';
import { IState } from '../../store';
import { elementShowed, initialized, playVideo, stopPlayVideo } from '../../store/gallery/';
import { trackGalleryFullScreenEnter } from '../../tracking';
import { TTypedThunkDispatch } from '../../types/store';

export function mapStateToProps(state: IState): IFotoramaStoreProps {
  return {
    showElementId: state.gallery.showElementId,
    slides: getSlides(state),
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    onElementShowed: () => {
      dispatch(elementShowed());
    },
    onInitialized: () => {
      dispatch(initialized());
    },
    onPlayVideo: () => {
      dispatch(playVideo());
    },
    onStopVideo: () => {
      dispatch(stopPlayVideo());
    },
    onFullScreenToggle: (opened: boolean) => {
      if (opened) {
        trackGalleryFullScreenEnter();
      }
    },
  };
}

export const FotoramaContainer = connect<IFotoramaStoreProps, IFotoramaDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Fotorama);
